import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { FaHome, FaArrowLeft } from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Container>
        <div className="not-found-content text-center">
          <div className="error-animation">
            <h1 className="error-code">404</h1>
            <div className="error-line"></div>
          </div>
          
          <h2 className="error-title mb-4">Oops! Page Not Found</h2>
          <p className="error-message mb-5">
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </p>
          
          <div className="error-actions d-flex gap-3 justify-content-center flex-wrap">
            <Button as={Link} to="/" variant="primary" size="lg">
              <FaHome className="me-2" />
              Go to Homepage
            </Button>
            <Button 
              onClick={() => window.history.back()} 
              variant="outline-primary" 
              size="lg"
            >
              <FaArrowLeft className="me-2" />
              Go Back
            </Button>
          </div>

          <div className="helpful-links mt-5">
            <p className="text-muted mb-3">Or try these helpful links:</p>
            <div className="links-grid">
              <Link to="/services" className="helpful-link">Services</Link>
              <Link to="/projects" className="helpful-link">Projects</Link>
              <Link to="/about" className="helpful-link">About Us</Link>
              <Link to="/contact" className="helpful-link">Contact</Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFound;